import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translator} from "../../core/setting/Translator";
import {TranslationTexts} from "../config/translate/TranslationTexts";
import {PunkRocker} from "../PunkRocker";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class PunkRocker2SlideShowPage extends SlideShowPage {
    constructor(texture?: PIXI.Texture) {
        super(undefined, undefined, undefined, undefined);

        if (texture) {

            const textStyle = new PIXI.TextStyle({
                fontFamily : OpenSans.FAMILY,
                fontStyle : FontStyle.NORMAL,
                fontWeight : FontWeight.BOLD,
                dropShadow: true,
                dropShadowAngle: 8,
                dropShadowBlur: 4,
                dropShadowDistance: 4,
                fill: "#FFFC00",
                fontSize: 30,
                lineJoin: "round",
                stroke: "#434343",
                strokeThickness: 4
            });

            const textObj = new PIXI.Text(Translator.translate(TranslationTexts.SPLASH_WIN_MORE) + " 30 000x " + Translator.translate(TranslationTexts.SPLASH_TIMES_BET),textStyle);
            textObj.anchor.set(0.5,0.5);
            textObj.position.set(0,175);
            if (PunkRocker.apiPlugin.gameClientConfiguration.isSet) {
                if (!PunkRocker.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                    textObj.visible = false;
                }
            } else {
                PunkRocker.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if (!PunkRocker.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                        textObj.visible = false;
                    }
                });
            }

            let featureImage: PIXI.Sprite = new PIXI.Sprite(texture);
            featureImage.anchor.set(0.5);
            this.addChild(featureImage);
            this.addChild(textObj);
        }
    }
}